module.exports = "<itpx-dynamic-grid\n    [fields]=\"fields\"\n    [url]=\"url\"\n    [refresh]=\"gridRefresh\"></itpx-dynamic-grid>"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/product-data/products/details/product-details-variants/product-details-variants.component.html
// module id = ./src/app/agora/components/product-data/products/details/product-details-variants/product-details-variants.component.html
// module chunks = main